import { take, put, call, fork, select } from 'redux-saga/effects'
import {
  FETCH_RELATED,
  FETCH_INLINE_RELATED,
  FETCH_SWIMLANE
} from './constants'
import {
  fetchRelatedApi,
  fetchInlineRelatedApi,
  apiFetchSwimlaneContent
} from './services'
import { fetchRelated, fetchInlineRelated, fetchSwimlane } from './actions'
import languages from '../../constants/languages'

function* relatedWorker(id, contentType, currentPhoneId) {
  if (!currentPhoneId) {
    // skip fetch when phone id is not set
    return yield put(fetchRelated.success([]))
  }
  const state = yield select()
  const language = languages[state.devicebits.language]
  const preSaleFlag = state.devicebits.preSaleFlag
  const customer = state.devicebits.customer
  let preSaleURL = preSaleFlag ? '&presales=1' : ''
  try {
    const response = yield call(fetchRelatedApi, {
      contentType,
      id,
      language,
      currentPhoneId,
      customer,
      preSaleURL
    })

    yield put(fetchRelated.success(response))
  } catch (e) {
    console.log('Related content fetch failed', e)
    yield put(fetchRelated.success([]))
  }
}

function* inlineRelatedWorker(id, contentType, currentPhoneId) {
  const state = yield select()
  const language = languages[state.devicebits.language]

  try {
    const response = yield call(fetchInlineRelatedApi, {
      contentType,
      id,
      language,
      currentPhoneId
    })

    if(!response.result) {
        yield put(fetchInlineRelated.success([]))
        return
    }

    const content = response.result.map(item => ({
      ...item,
      object_type: item.content_type,
      pk: item.PK
    }))

    yield put(fetchInlineRelated.success(content))
  } catch (e) {
    console.log('Suggested fetch failed', e)
    yield put(fetchInlineRelated.success([]))
  }
}

function* fetchSwimlaneWorker() {
  const state = yield select()
  const currentPhoneId = state.devicebits.currentPhoneId
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  try {
    const response = yield call(
      apiFetchSwimlaneContent,
      currentPhoneId,
      preSaleFlag,
      language,
      customer
    )

    yield put(fetchSwimlane.success(response))
  } catch (e) {
    console.log('Swimlane content fetch failed', e)
    yield put(fetchSwimlane.success([]))
  }
}

function* relatedWatcher() {
  while (true) {
    const { id, contentType, currentPhoneId } = yield take(
      FETCH_RELATED['REQUEST']
    )
    yield call(relatedWorker, id, contentType, currentPhoneId)
  }
}

function* inlineRelatedWatcher() {
  while (true) {
    const { id, contentType, currentPhoneId } = yield take(
      FETCH_INLINE_RELATED['REQUEST']
    )
    yield call(inlineRelatedWorker, id, contentType, currentPhoneId)
  }
}

function* fetchSwimlaneWatcher() {
  while (true) {
    yield take(FETCH_SWIMLANE['REQUEST'])
    yield call(fetchSwimlaneWorker)
  }
}

export default function* rootSaga() {
  yield fork(relatedWatcher)
  yield fork(inlineRelatedWatcher)
  yield fork(fetchSwimlaneWatcher)
}



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/sagas.js